var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57452 11.1171C9.33944 11.1171 10.7702 9.66998 10.7702 7.88487C10.7702 6.09975 9.33944 4.65263 7.57452 4.65263C5.8096 4.65263 4.37885 6.09975 4.37885 7.88487C4.37885 9.66998 5.8096 11.1171 7.57452 11.1171Z",
    stroke: "black",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.45962 6.02829V11.3072C1.53702 11.6204 1.79135 12.4816 2.5875 13.1974C3.3726 13.9132 4.2351 14.0697 4.55577 14.1145H12.3293C12.462 14.0809 13.0591 13.9355 13.424 13.354C13.6231 13.0296 13.6673 12.7053 13.6784 12.5375V5.87171C13.6231 5.71513 12.7716 4.02632 12.0529 3.37764C10.6486 2.10264 9.06731 1.90132 8.52548 1.85658L5.06442 2.01316C4.6774 2.09145 3.51635 2.40461 2.56539 3.50066C1.69183 4.51842 1.5149 5.62566 1.47067 6.02829H1.45962Z",
    stroke: "black",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5394 3.94803C13.3135 4.79803 13.8663 5.50264 14.2202 5.99474C14.2202 5.99474 14.4635 6.33027 14.9168 7.14672C15.2817 7.7954 15.337 8.0079 15.2817 8.20922C15.1712 8.60066 14.6846 8.77961 14.5298 8.83553L13.601 9.20461",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13C11.7761 13 12 12.7761 12 12.5C12 12.2239 11.7761 12 11.5 12C11.2239 12 11 12.2239 11 12.5C11 12.7761 11.2239 13 11.5 13Z",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0317 11.3184H19.5942V15.971H21.0317V11.3184Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7115 11.3184H19.5942V14.1816H12.3404C12.2187 14.1816 12.5837 14.1816 12.7053 14.1816",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.751 12.5711V11.3967",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5803 11.3743V12.0566",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5091 12.5487V11.3743",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2452 12.5487V11.3743",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3385 11.3967V12.0789",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.efc51a209c56537c46579b9a7f26c410.svg";
export { ForwardRef as ReactComponent };